import React from 'react'
import styled from 'styled-components'
import Link from 'next/link'
import { createResource, useResource } from '@/lib/i18n'
import { useCurrentLanguage } from '@/lib/current-language'

const resource = createResource({
  en: {
    title: 'Financial Statement:',
    fileName: '2023 Financial Statement',
    fileName2024: '2024 Financial Statement',
    fileName2025: '2025 Financial Statement',
  },
  id: {
    title: 'Laporan Keuangan',
    fileName: 'Laporan Keuangan 2023',
    fileName2024: 'Laporan Keuangan 2024',
    fileName2025: 'Laporan Keuangan 2025',
  },
})

const Financial = () => {
  const { t } = useResource(resource)
  const env = process.env.NEXT_PUBLIC_HOST_URL
  const { language: lng } = useCurrentLanguage()
  return (
    <BannerBox>
      <div className="container">
        <div className="content">
          <div className="title">{t('title')}</div>
          <Link
            href={env + '/Publikasi%20Laporan%20Keuangan%20Audited%20Tahun%202023.pdf'}
            rel="noopener noreferrer nofollow"
            className="file"
            target="_blank"
          >
            {t('fileName')}
          </Link>
          <br />
          <Link
            href={env + '/Publikasi%20Laporan%20Keuangan%20Audited%20Tahun%202024.pdf'}
            rel="noopener noreferrer nofollow"
            className="file"
            target="_blank"
          >
            {t('fileName2024')}
          </Link>
          <br />
          <Link href={ env + "/Publikasi%20Laporan%20Keuangan%20Audited%20Tahun%202025.pdf" }>
            <a rel="noopener noreferrer nofollow" className="file" target="_blank">
              {t('fileName2025')}
            </a>
          </Link>
        </div>
      </div>
    </BannerBox>
  )
}

export default Financial

const BannerBox = styled.div`
  @media only screen and (max-width: 1000px) {
    margin-top: 36px;
    .container {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      .title {
        height: 48px;
        font-size: 28px;
        font-family: Roboto-Medium, Roboto;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.87);
        line-height: 48px;
      }
      .file {
        height: 36px;
        font-size: 20px;
        font-family: Roboto-Regular, Roboto;
        font-weight: 400;
        color: #1cc812;
        line-height: 36px;
        text-decoration: underline;
      }
    }
  }
  @media only screen and (min-width: 1000px) {
    max-width: 1140px;
    margin: 0 auto;
    .container {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 448px;
      width: 100%;
      max-width: 1140px;
      margin: 0 auto;
      border-bottom: 1px solid #c2c2c2;
      .title {
        height: 48px;
        font-size: 36px;
        font-family: Roboto-Medium, Roboto;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.87);
        line-height: 48px;
      }
      .file {
        height: 36px;
        font-size: 28px;
        font-family: Roboto-Regular, Roboto;
        font-weight: 400;
        color: #1cc812;
        line-height: 66px;
        text-decoration: underline;
      }
    }
  }
`
